import {ActionTree} from 'vuex';
import {WidgetState} from "@/apps/MyStudyChoiceAuthenticationWidget/models/store-viewmodel";

export default <ActionTree<WidgetState, any>>{
    setConfig(context, payload) {
        context.commit('setConfig', payload)
    },
    toggleAuthenticationWidgetVisible(context, payload) {
        context.commit('toggleAuthenticationWidgetVisible', payload)
    }
}
